// Packages
import React from 'react';
import { Box, IconButton, Link, Stack } from '@mui/material';
import { useBlockingRouter } from '../../../hooks/useBlockingRouter';

// Markup
import { Button } from '../../Button';
import { Logo2 as Logo } from '../../../blocks/Logo2';
import { HelpButton } from '../../../mui/HelpButton/HelpButton';

import useIsLoggedIn from '../../../hooks/useIsLoggedIn';
import useIsOnBoardingRoute from '../../../hooks/useIsOnBoardingRoute';
import { Avatar } from './Avatar';
import { BurgerIcon, CloseIcon } from '../../../mui/Icons';
import styles from './Header.module.scss';
import { useDeviceDetection } from '../../../hooks/useDeviceDetection';
import { EventNotifications } from './EventNotifications';
import { FlattenedUser } from '../../../types/user';
import { useSelector } from 'react-redux';
import { UserType } from '#types';

export type HeaderProps = {
	isActiveMobileMenu: boolean;
	toggleMobileMenu: ( active: boolean ) => void;
};

export const Header: React.FC<HeaderProps> = ( {
	toggleMobileMenu,
	isActiveMobileMenu,
} ) => {
	const user: FlattenedUser = useSelector( ( state: any ) => state.user );
	const { isDesktop } = useDeviceDetection();
	const isOnBoardingRoute = useIsOnBoardingRoute();
	const isLoggedIn = useIsLoggedIn();
	const router = useBlockingRouter();
	const { pathname: currentRoute } = router;

	const hasEventNotifications =
		user?.isLoggedIn &&
		( user.userType === UserType.OrgUser ||
			user.userType === UserType.ClientUser );

	return (
		<Box component='header' className={ styles.root }>
			<Link
				href={ user?.isLoggedIn ? '/' : '/Login' }
				tabIndex={ 1 }
				className={ styles.logo }
				data-cy='headerLogo'
				onClick={ () => toggleMobileMenu( false ) }
			>
				<Logo />
			</Link>
			<div className={ styles.rightControls }>
				{ !isLoggedIn && currentRoute === '/Login' && (
					<Button className={ styles.button } color='secondary' href='/SignUp'>
						Sign Up
					</Button>
				) }
				{ !isLoggedIn && currentRoute === '/SignUp' && !isOnBoardingRoute && (
					<Button className={ styles.button } color='secondary' href='/Login'>
						Sign In
					</Button>
				) }

				{ isLoggedIn && !isOnBoardingRoute && (
					<Stack className={ styles.headerRow }>
						{ hasEventNotifications ? <EventNotifications /> : null }
						{ isDesktop ? (
							<>
								<Avatar />
								<HelpButton />
							</>
						) : (
							<div className={ styles.mobileToggleWrap }>
								{ isActiveMobileMenu ? (
									<IconButton
										className={ styles.mobileCloseButton }
										onClick={ () => toggleMobileMenu( false ) }
									>
										<CloseIcon />
									</IconButton>
								) : (
									<IconButton
										className={ styles.mobileOpenButton }
										onClick={ () => toggleMobileMenu( true ) }
									>
										<BurgerIcon />
									</IconButton>
								) }
							</div>
						) }
					</Stack>
				) }
			</div>
		</Box>
	);
};
